import React from "react";
import db from "../../firebase";  
import { useCollectionData } from "react-firebase-hooks/firestore";
import moment from "moment";
import { Link } from "react-router-dom";

const AuthorNtime = (props) => {
    const authorsRef = db.collection("authors");
    const AuthorsQuery = authorsRef.where("name", "==", props.name);
    const [author] = useCollectionData(AuthorsQuery);
    return (
        <section className="row m-0" id="authorNtime">
            <div className="col-1 p-0">
                <Link to={author ? `/authors/${author[0].name}` : ""}><img id="topDP" className="postDp" src={author && author[0].dpSrc} alt="" /></Link>
            </div>
            <div className="col">
                <p id="nameAndTime">
                    <b>{author && author[0].name}</b>
                    &nbsp;| {moment(props.time.toDate()).calendar()}
                    &nbsp;| 7 min read
                </p> 
            </div>
        </section>

    );
}

export default AuthorNtime;